var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconBarnRegular = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 19.5v-9h3.603l.731-1.569a2.249 2.249 0 0 1 1.104-1.093A3.502 3.502 0 0 0 7.5 5 3.498 3.498 0 0 0 4 8.5v11A1.5 1.5 0 0 0 5.5 21h3.128a2.744 2.744 0 0 1-.619-1.5H5.5zM9.5 9h-4v-.5c0-1.103.897-2 2-2s2 .897 2 2V9zm2.56 1.075 3.44-1.506 3.44 1.506 1.56 3.344v5.831a.25.25 0 0 1-.25.25H17.5v-1.75c0-.69-.56-1.25-1.25-1.25h-1.5c-.69 0-1.25.56-1.25 1.25v1.75h-2.75a.25.25 0 0 1-.25-.25v-5.834l1.56-3.344v.003zM16 7.15a1.245 1.245 0 0 0-1.003 0l-3.625 1.588a1.25 1.25 0 0 0-.631.615l-1.622 3.478A1.241 1.241 0 0 0 9 13.36v5.891c0 .966.784 1.75 1.75 1.75h9.5c.966 0 1.75-.784 1.75-1.75v-5.89c0-.182-.04-.363-.119-.529L20.26 9.353a1.25 1.25 0 0 0-.63-.615L16 7.15zm-2 5.6v1.5c0 .416.334.75.75.75h1.5c.416 0 .75-.334.75-.75v-1.5a.748.748 0 0 0-.75-.75h-1.5a.748.748 0 0 0-.75.75z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBarnRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-barn-regular.1fc86cd8.svg";
export { ForwardRef as ReactComponent };